module.exports = "/_next/static/images/4b2ea02bd80f14a563c11e9db4d326e1-nubanker-tpm@1x.jpg.webp";